var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('p',{staticClass:"footer__copy-right"},[_vm._v(" Copyright © 2021 by PLURIPOTENT ART. "),(_vm.isMobile)?_c('br'):_vm._e(),_vm._v(" All pictures cannot be copied without permission. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }